
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/highlight/[slug]",
      function () {
        return require("private-next-pages/highlight/[slug].js");
      }
    ]);
  